import imgRoomOneDraw from "@/assets/images/offer/Plan_KM_H-2-86.png";
import imgRoomTwoDraw from "@/assets/images/offer/Plan_KM_H-4-150.png";
import imgRoomThreeDraw from "@/assets/images/offer/Plan_KM_H-4-162.png";
import imgRoomOneGallery1 from "@/assets/images/offer/gallery-1.jpg";
import imgRoomOneGallery2 from "@/assets/images/offer/gallery-2.jpg";
import imgRoomOneGallery3 from "@/assets/images/offer/gallery-3.jpg";
import { ApartamentType } from "@/types/ApartamentType";

export default function getApartmentsData(): Array<ApartamentType> {
  return [
    {
      id: "apartament-86",
      slug: "apartament-86",
      name: "Apartament 86",
      nameGenitive: "Apartamentu 86",
      pdfFile: "/pdf/KM_H-2-86.pdf",
      imageVisual: null,
      imageDraw: imgRoomOneDraw,
      imageGallery: [
        {
          original: imgRoomOneGallery1,
          thumbnail: imgRoomOneGallery1,
        },
        {
          original: imgRoomOneGallery2,
          thumbnail: imgRoomOneGallery2,
        },
        {
          original: imgRoomOneGallery3,
          thumbnail: imgRoomOneGallery3,
        },
      ],
      floor: 2,
      price: 575357,
      yearly_profit: 10000,
      inside: [
        {
          name: "Pokój",
          metric: 22.13,
        },
        {
          name: "Łazienka",
          metric: 2.94,
        },
      ],
      outside: [
        {
          name: "Balkon",
          metric: 5.77,
        },
      ],
    },
    {
      id: "apartament-150",
      slug: "apartament-150",
      name: "Apartament 150",
      nameGenitive: "Apartamentu 150",
      pdfFile: "/pdf/KM_H-4-150.pdf",
      imageVisual: null,
      imageDraw: imgRoomTwoDraw,
      imageGallery: [
        {
          original: imgRoomOneGallery1,
          thumbnail: imgRoomOneGallery1,
        },
        {
          original: imgRoomOneGallery2,
          thumbnail: imgRoomOneGallery2,
        },
        {
          original: imgRoomOneGallery3,
          thumbnail: imgRoomOneGallery3,
        },
      ],
      floor: 4,
      price: 1437719,
      yearly_profit: 10000,
      inside: [
        {
          name: "Pokój",
          metric: 27.14,
        },
        {
          name: "Sypialnia",
          metric: 21.8,
        },
        {
          name: "Łazienka",
          metric: 11.09,
        },
      ],
      outside: [
        {
          name: "Balkon",
          metric: 4.37,
        },
      ],
    },
    {
      id: "apartament-162",
      slug: "apartament-162",
      name: "Apartament 162",
      nameGenitive: "Apartamentu 162",
      pdfFile: "/pdf/KM_H-4-162.pdf",
      imageVisual: null,
      imageDraw: imgRoomThreeDraw,
      imageGallery: [
        {
          original: imgRoomOneGallery1,
          thumbnail: imgRoomOneGallery1,
        },
        {
          original: imgRoomOneGallery2,
          thumbnail: imgRoomOneGallery2,
        },
        {
          original: imgRoomOneGallery3,
          thumbnail: imgRoomOneGallery3,
        },
      ],
      floor: 4,
      price: 661573,
      yearly_profit: 10000,
      inside: [
        {
          name: "Pokój",
          metric: 18.82,
        },
        {
          name: "Łazienka",
          metric: 3.96,
        },
        {
          name: "Sypialnia",
          metric: 7.36,
        },
      ],
      outside: [
        {
          name: "Balkon",
          metric: 8.34,
        },
      ],
    },
  ];
}
